export const OfflineStorage = {
  init: function() {
    if (typeof Storage === "undefined" && window.inMemoryStorage === undefined)
      window.inMemoryStorage = window.inMemoryStorage || [];
  },
  setItem: function(key, value, isPersistant) {
    if (typeof Storage !== "undefined") {
      if (isPersistant) {
        localStorage.setItem(key, value);
      } else {
        sessionStorage.setItem(key, value);
      }
    } else {
      //Store token in global Variable so it can be accessed in same session
      window.inMemoryStorage[key] = value;
    }
  },
  getItem: function(key, isPersistant) {
    //IF Local Storage is available
    if (typeof Storage !== "undefined") {
      if (isPersistant) {
        return localStorage.getItem(key);
      } else {
        return sessionStorage.getItem(key);
      }
    } else {
      if (window.inMemoryStorage) {
        return window.inMemoryStorage[key];
      }
    }
    return null;
  },
  deleteItem: function(key, isPersistant) {
    //IF Local Storage is available
    if (typeof Storage !== "undefined") {
      if (isPersistant) {
        localStorage.removeItem(key);
      } else {
        sessionStorage.removeItem(key);
      }
    } else {
      if (window.inMemoryStorage) {
        delete window.inMemoryStorage[key];
      }
    }
  },
  clear: function(isPersistant) {
    //IF Local Storage is available
    if (typeof Storage !== "undefined") {
      if (isPersistant) {
        localStorage.clear();
      } else {
        sessionStorage.clear();
      }
    } else {
      if (window.inMemoryStorage) {
        delete window.inMemoryStorage;
      }
    }
  }
};
OfflineStorage.init();
